import React, { useState, useEffect } from "react";
import Dialog from '@mui/material/Dialog';
import Slider from "@material-ui/core/Slider";
import RadioButtonGroup from './RadioButtonGroup'
import ReactGA from "react-ga";
import {
    utilityLogoMatlib,
    closeIcon
  } from "./Icons";

const marks = [
    {
        value: 30,
        label:'Maybe too much!'
      },
    {
      value: 20,
      label:'default'
    },
    {
        value: 1,
        label:'None'
      }

  ];

export default function SettingsModal(props) {

  const { settingDialog, setSettingDialog, setColorDelta, similarColorThumb, setSimilarColorThumb, enableToolTip, setEnableToolTip, colorDelta} = props;
  const [newDelta, setNewDelta] = useState(colorDelta);

  const handleChange = (event, newValue) => {
    setNewDelta(newValue);
    
  };
  const handleToolTipEnable = () => {
    console.log(enableToolTip)
    setEnableToolTip(!enableToolTip)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
       setColorDelta(newDelta)
       localStorage.setItem('delta', newDelta)
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [newDelta]);

  if (settingDialog) {

    ReactGA.pageview(
      window.location.pathname + `/settings`
    );

    return (
      <Dialog
        className="modal"
        maxWidth={"md"}
        open={settingDialog}
        onClose={() => setSettingDialog(false)}
        aria-labelledby="form-dialog-title"
      >
        <div className="settings-modal-view">
            <div className="settings-modal-view-close" onClick={() => setSettingDialog(false)}>{closeIcon}</div>
          <h3>CONTROL PANEL</h3>
          <div className="setting-modal-section">
            <h5>COLOR TONES DELTA</h5>
            <Slider
            key={`slider-${newDelta}`}
              defaultValue={newDelta}
              aria-label="Default"
              valueLabelDisplay="auto"
              onChange={handleChange}
              value={newDelta}
              min={1}
              max={30}
              marks={marks}
              style={{ width: "70%" }}
            />
          </div>
          <div className="setting-modal-section">
          <h5>TONE SWATCH SIZE</h5>
            <RadioButtonGroup similarColorThumb={similarColorThumb} setSimilarColorThumb={setSimilarColorThumb}/>
          </div>
          <div className="setting-modal-section">
            <button onClick={handleToolTipEnable}>{enableToolTip ? <h5> DISABLE TOOL TIPS </h5> : <h5> ENABLE TOOL TIPS </h5>}</button>
          </div>
          <div className="setting-modal-section"><span className="utility-logo">{utilityLogoMatlib}</span></div>
         </div>
      </Dialog>
    );
  }
  return null;
}
